import Model from "../Model";

export default class extends Model {
    async loadTable(
        release_id,
        filter,
        page,
        per_page,
        search = '',
    ) {
        let pages = 1;
        let response = await axios.get(this.urls.list, {
            params: {
                release_id,
                filter,
                page,
                per_page,
                search,
            }
        }).then(response => {

            pages = response.data.meta.last_page;

            if(response.data.data !== undefined)
            {
                if(response.data.data.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: pages,
        };

        if(response.data !== undefined && response.data.length > 0)
        {
            response.data.forEach(assignment_device => {
                let telem = {
                    tbody: {}
                };
                telem.device_id = assignment_device.device_id;
                telem.tbody.device_type = assignment_device.device_type;
                telem.tbody.device_item = assignment_device.device_item;
                telem.tbody.pharmacy_number = assignment_device.pharmacy_number;
                telem.tbody.location = assignment_device.location;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
